"use client";

import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { BASE_URL } from "../config/constants";

const UserProfile = () => {
  const { id } = useParams();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await fetch(
          `${BASE_URL}/api/v1/courses/public?page=1&limit=50`
        );
        const data = await res.json();

        const projectCourses =
          data?.courses?.filter((course) => course.type === "PROJECT") || [];
        setProjects(projectCourses);
      } catch (error) {
        console.error("Error fetching courses:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, [id]);

  if (loading)
    return (
      <p className="text-center mt-10 text-blue-500 min-h-screen flex justify-center items-center">
        جاري التحميل...
      </p>
    );
  if (error)
    return (
      <p className="text-center mt-10 text-red-500 min-h-screen flex justify-center items-center">
        {error}
      </p>
    );
  if (!user)
    return (
      <p className="text-center mt-10 text-gray-500 min-h-screen flex justify-center items-center">
        المستخدم غير موجود
      </p>
    );

  return (
    <div className="p-6 max-w-xl mx-auto bg-white rounded-xl shadow-lg mt-10 text-center min-h-screen ">
      {/* الاسم والدور */}
      <h1 className="text-2xl font-bold mt-4 text-gray-800">
        {user.firstName} {user.lastName}
      </h1>
      <p className="text-sm text-gray-500 mt-1">{user.role?.name || "عضو"}</p>

      {/* بيانات الاتصال */}
      <div className="mt-4 space-y-2 text-gray-700">
        <p>
          <span className="font-semibold">البريد:</span>{" "}
          {user.email || "غير متوفر"}
        </p>
        <p>
          <span className="font-semibold">الهاتف:</span>{" "}
          {user.phone || "غير متوفر"}
        </p>
        <p>
          <span className="font-semibold">الحالة:</span>{" "}
          {user.status?.name || "غير متوفر"}
        </p>
      </div>

      {/* تواريخ الإنشاء والتحديث */}
      <div className="mt-4 text-gray-400 text-xs">
        <p>تاريخ الإنشاء: {new Date(user.createdAt).toLocaleString("ar-EG")}</p>
        <p>آخر تعديل: {new Date(user.updatedAt).toLocaleString("ar-EG")}</p>
      </div>
    </div>
  );
};

export default UserProfile;
